import React, {Fragment} from 'react';
import type {NoProps} from 'types';
import {ThemeColors} from 'theme/themeColors';
import {selectHead} from 'services/head/headSlice';
import {useAppSelector} from 'store/hooks';

type Props = NoProps;

export const Head: React.FC<Props> = () => {
  const {title, description} = useAppSelector(selectHead);

  return (
    <Fragment>
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content={ThemeColors.text.primary.main} />
      <meta name="description" content={description} />
      <title>{title ? `${title} | Ebba` : 'Ebba'}</title>
    </Fragment>
  );
};
